import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';
import SpaceAround from './SpaceAround';


/*

Props:


*/

const StyledDiv = styled.div`
  display: flex; 
  flex-grow: 1;
  width: 100%;
  justify-content: flex-end; 
  align-items: center; 
  max-width: ${constants.layout.contentWidth.maxWidth - 20}px;
  padding-right: ${constants.layout.contentWidth.paddingRight}px;
  padding-left: ${constants.layout.contentWidth.paddingRight}px;
`;

const FlexEnd = ({ styles, children }) => (
  <SpaceAround>
    <StyledDiv style = {styles}>
        { children }
    </StyledDiv>
  </SpaceAround>
)

export default FlexEnd



// WEBPACK FOOTER //
// ./src/js/components/Positioners/FlexEnd.jsx